<template>
    <div class="software-page">
        <h1>Smart Hotel Solution</h1>

        <!-- 头部深色区域：还原参考图的质感 -->
        <section class="detail-gallery-section">

            <!-- v-for 循环渲染图文块 -->
            <div class="detail-gallery-block" v-for="(item, index) in galleryList" :key="index">
                <!-- 文本区域 -->
                <div class="detail-text-block" style="text-align: left;">
                    <p>{{ item.text }}</p>
                    <p v-if="item.text1 !== ''">{{ item.text1 }}</p>
                </div>

                <!-- 图片与热区容器 -->
                <div class="detail-gallery-item">
                    <!-- 关键容器：相对定位，宽度与图片一致 -->
                    <div class="image-hotspot-container">
                        <el-image :src="item.image" class="detail-media" lazy>
                        </el-image>

                        <!-- 循环渲染当前图片的所有热区 -->
                        <div v-for="(hotspot, hIndex) in item.hotspots" :key="hIndex" class="hotspot-rect" :style="{
                            left: hotspot.x + '%',
                            top: hotspot.y + '%',
                            width: hotspot.width + '%',
                            height: hotspot.height + '%'
                        }" @click="handleHotspotClick(hotspot.targetRoute)">
                            <!-- 开发调试时可以把 CSS 里的背景色打开，上线时设为透明 -->
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

// 核心数据结构：配置所有的文案、图片和跳转热区
const galleryList = ref([
    {
        text: "This is our hotel solution, which incorporates a range of smart devices including a 4-inch Zigbee central control panel, a card holder, smart switches, smart curtains, smart dimming controls, and an IR blaster.",
        text1: "All devices within the room connect to the 4-inch central control panel via the Zigbee protocol, enabling a fully smart environment.",
        image: "https://qiniu-us.wifigsmalarm.com/images/solutions/hotel_solution_1.jpg",
        hotspots: [
            // {
            //     // 百分比定位，相对于图片本身
            //     x: 2,       // 距离左侧 10%
            //     y: 10,       // 距离顶部 20%
            //     width: 8,   // 宽占图片的 30%
            //     height: 12,  // 高占图片的 15%
            //     targetRoute: "/lobby-detail" // 路由跳转地址
            // },
            // {
            //     // 百分比定位，相对于图片本身
            //     x: 2,       // 距离左侧 10%
            //     y: 41,       // 距离顶部 20%
            //     width: 10,   // 宽占图片的 30%
            //     height: 12,  // 高占图片的 15%
            //     targetRoute: "/lobby-detail" // 路由跳转地址
            // },
            // {
            //     // 百分比定位，相对于图片本身
            //     x: 2,       // 距离左侧 10%
            //     y: 68,       // 距离顶部 20%
            //     width: 8,   // 宽占图片的 30%
            //     height: 12,  // 高占图片的 15%
            //     targetRoute: "/lobby-detail" // 路由跳转地址
            // },
            // {
            //     // 百分比定位，相对于图片本身
            //     x: 25,       // 距离左侧 10%
            //     y: 70,       // 距离顶部 20%
            //     width: 8,   // 宽占图片的 30%
            //     height: 12,  // 高占图片的 15%
            //     targetRoute: "/lobby-detail" // 路由跳转地址
            // },
        ]
    },
    {
        text: "When a user stands and presses the doorbell on the doorplate, the doorbell inside the room will ring.",
        text1: "As someone enters, the human presence radar mounted on the entryway ceiling is triggered, turning on the lights in the foyer. Once the room key card is inserted, power is supplied to all devices throughout the room, and the \"Check-in\" mode is activated.",
        image: "https://qiniu-us.wifigsmalarm.com/images/solutions/hotel_solution_2.png", // 替换为你的第二张图
        hotspots: [

        ]
    },
    {
        text: "Inside the room, you can control all smart devices and preset scene modes via a mobile app, a 4-inch central control screen, or the T3E-K control panel located by the bedside. For instance, using these interfaces—which communicate via an infrared (IR) bridge—you can change television channels, open or close curtains, adjust the brightness and color temperature of the lights, or trigger a specific \"Scene Mode\" that commands all devices to perform a pre-configured set of actions simultaneously.",
        image: "https://qiniu-us.wifigsmalarm.com/images/solutions/hotel_solution_3.png", // 替换为你的第二张图
        hotspots: [

        ]
    }
]);

// 点击热区跳转逻辑
const handleHotspotClick = (routePath) => {
    if (routePath) {
        console.log("Navigating to:", routePath);
        router.push(routePath);
    }
};
</script>

<style scoped>
/* =========================================
   全局与基础样式
   ========================================= */
.software-page {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    width: 100%;
    overflow-x: hidden;
    margin-top: 10vh;
}

.pc-only {
    display: block;
}

.detail-gallery-section {
    border-top: 2px solid #f2f2f2;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 64px;
    /* 增加每个图文块之间的间距 */
    align-items: center;
}

.detail-gallery-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

.detail-text-block {
    width: 100%;
    /* 文本区建议保持在 900px - 1000px 左右，太宽的话阅读视线跨度太大，容易疲劳 */
    max-width: 1200px;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: center;
    /* 根据你的排版需求，可以让文字居中或左对齐 */
}

.detail-text-block p {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin: 0;
}

.detail-gallery-item {
    width: 100%;
    display: flex;
    justify-content: center;
}

/* =========================================
   图片与热区定位核心逻辑
   ========================================= */
.image-hotspot-container {
    position: relative;
    width: 100%;
    /* 【核心修改】：将原本的 900px 调大。
       1200px 适合大多数常规宽屏，如果是大尺寸的高清产品架构图，可以调到 1440px 
       或者直接写 width: 90%; max-width: 1600px; 让它在PC端自适应屏幕宽度 
    */
    max-width: 1200px;
    margin: 0 auto;
    /* 确保容器在屏幕中央 */

    /* 可选：给 PC 端的图片加一点优雅的阴影，提升质感 */
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
}

.detail-media {
    width: 100%;
    height: auto;
    border-radius: 8px;
    /* 配合外层容器的圆角 */
    display: block;
}

.hotspot-rect {
    position: absolute;
    cursor: pointer;
    z-index: 10;

    /* TODO: 调试模式下的红色半透明背景，确定位置没问题后改成 transparent */
    /* background-color: rgba(255, 0, 0, 0.3); */
    background-color: transparent;
}

.hotspot-rect:hover {
    /* 悬浮时可以给一点交互提示，比如极淡的白色遮罩 */
    background-color: rgba(255, 255, 255, 0.2);
}

/* =========================================
   移动端适配 (Mobile Responsive)
   ========================================= */
@media screen and (max-width: 768px) {
    .pc-only {
        display: none;
    }

    .detail-gallery-section {
        padding-top: 30px;
        gap: 40px;
    }

    .detail-media {
        border-radius: 0;
        /* 手机端去掉圆角 */
    }

    .image-hotspot-container {
        max-width: 100%;
        /* 手机端全宽撑满 */
        box-shadow: none;
        /* 手机端去掉阴影 */
        border-radius: 0;
        /* 手机端去掉外层圆角 */
    }
}
</style>